import { INSIDER_FILTER_PARAMS } from '@/Groups/Polymarket/private/constants/config';

//Функция сортировки map на основе активного фильтра
export function sortMapByFilter(state) {
  //В insider-режиме порядок задаёт бэк (по open_positions_value_usd) — не пересортируем.
  if (INSIDER_FILTER_PARAMS.includes(state.filters.top)) return;

  if (!state.filters.top || state.filters.top === 'bet_value') {
    state.map.sort((a, b) => {
      const dateA = new Date(state.data[a]?.created_at || 0);
      const dateB = new Date(state.data[b]?.created_at || 0);
      return dateB - dateA;
    });
    return;
  }
  
  if (state.filters.top === 'top_pnl_24h') {
    state.map.sort((a, b) => {
      const pnlA = state.data[a]?.pnl || 0;
      const pnlB = state.data[b]?.pnl || 0;
      return pnlB - pnlA;
    });
    return;
  }
  
  if (state.filters.top === 'top_trades_24h') {
    state.map.sort((a, b) => {
      const amountA = state.data[a]?.amount_usd || 0;
      const amountB = state.data[b]?.amount_usd || 0;
      return amountB - amountA;
    });
  }
}
